







































import { dateFormat } from "@/utils/timeFormat";
import { getStoreShareInfoApi } from "@/api/store";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  shareData = {
    cover: "",
    qrCode: "",
    orgName: "",
  };
  dialogVisible: boolean = false;
  openDialog() {
    this.dialogVisible = true;
    // 获取门店分享信息
    getStoreShareInfoApi().then((res: any) => {
      const params = {
        cover: res.data.org.image_url,
        qrCode: res.data.weapp_code_url,
        orgName: res.data.org.org_name,
      };
      this.shareData = params;
      this.createPoster(params);
    });
  }
  createPoster(option: { cover: string; qrCode: string; orgName: string }) {
    const canvas: any = document.getElementById("share-poster");
    const ctx = canvas.getContext("2d");
    const scale = 2;
    // 背景
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 380 * scale, 320 * scale);
    // 封面图片
    const cover = new Image();
    cover.onload = function () {
      ctx.drawImage(cover, 0, 0, 380 * scale, 214 * scale);
    };
    cover.src = option.cover;
    cover.crossOrigin = "Anonymous";
    // 二维码
    const qrCode = new Image();
    qrCode.onload = function () {
      ctx.drawImage(qrCode, 285 * scale, 230 * scale, 80 * scale, 80 * scale);
    };
    qrCode.src = option.qrCode;
    qrCode.crossOrigin = "Anonymous";
    // 门店名称
    ctx.font = `${18 * scale}px Microsoft YaHei`;
    ctx.fillStyle = "#333";
    if (option.orgName.length > 12) {
      ctx.fillText(option.orgName.slice(0, 12), 20 * scale, 248 * scale);
      ctx.fillText(option.orgName.slice(12), 20 * scale, 276 * scale);
    } else {
      ctx.fillText(option.orgName, 20 * scale, 250 * scale);
    }
    // 提示语
    ctx.font = `${12 * scale}px Microsoft YaHei`;
    ctx.fillStyle = "#999";
    ctx.fillText("打开微信扫一扫了解详情", 20 * scale, 307 * scale);
  }
  handleSavePoster() {
    const canvasDom: any = this.$refs["share-poster"];
    const imageData = canvasDom.toDataURL("image/png");
    const elink = document.createElement("a");
    elink.download = `${this.shareData.orgName}_${dateFormat(
      "YYYYmmddHHMMSS",
      new Date()
    )}.png`;
    elink.style.display = "none";
    elink.href = imageData;
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  }
  handleDownloadQrCode() {
    const image = new Image();
    const self = this;
    image.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const context: any = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      const url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      const event = new MouseEvent("click");
      a.download = `${self.shareData.orgName}_${dateFormat(
        "YYYYmmddHHMMSS",
        new Date()
      )}.png`;
      a.href = url;
      a.dispatchEvent(event);
    };
    image.src = this.shareData.qrCode;
    image.crossOrigin = "Anonymous";
  }
}
